import { isNil, replace, toString } from 'lodash';

export const numberToStringWithCommas = (number?: number | null) =>
  isNil(number) ? '' : replace(toString(number), /\B(?=(\d{3})+(?!\d))/g, ',');
